module.exports = __webpack_public_path__ + "img/customer_tag_2.8ac4717a.webp";